export const fantomZaps = [
  {
    // SpookySwap
    zapAddress: '0x8afc0f9BdC5DcA9f0408Df03A03520bFa98A15aF',
    ammRouter: '0xF491e7B69E4244ad4002BC14e878a34207E38c29',
    ammFactory: '0x152eE697f2E276fA89E96742e9bB9aB1F2E61bE3',
    ammPairInitHash: '0xcdf2deca40a0bd56de8e3ce5c7df6727e5b1bf2ac96f283fa9c4b3e6b42ea9d2',
  },
];
